export const ExtractionProgressBar = {
  mounted() {
    this.timers = {}
    this.warningTimers = {}
    this.warningFired = {}
    this.failureTimers = {}
    this.failureFired = {}
    this.checkSteps()
  },

  updated() {
    this.checkSteps()
  },

  getSteps() {
    return JSON.parse(this.el.dataset.steps)
  },

  getCurrentStep() {
    const steps = this.getSteps()
    let currentIndex = 0

    for (let i = 0; i < steps.length; i++) {
      const status = steps[i].status
      if (status === "completed" || status === "skipped") {
        currentIndex = i + 1
      } else {
        break
      }
    }

    return steps[currentIndex]
  },

  checkSteps() {
    const steps = this.getSteps()

    // Reset state for steps that are back to pending (happens on retry)
    steps.forEach((step) => {
      if (step.status === "pending") {
        if (this.timers[step.name]) {
          clearInterval(this.timers[step.name])
          delete this.timers[step.name]
        }
        if (this.warningTimers[step.name]) {
          clearTimeout(this.warningTimers[step.name])
          delete this.warningTimers[step.name]
        }
        if (this.failureTimers[step.name]) {
          clearTimeout(this.failureTimers[step.name])
          delete this.failureTimers[step.name]
        }
        delete this.warningFired[step.name]
        delete this.failureFired[step.name]
      }
    })

    const currentStep = this.getCurrentStep()
    const ts = new Date().toISOString()

    console.log(
      `[ProgressBar ${ts}] Step statuses:`,
      steps.map((s) => `${s.name}:${s.status}`).join(", "),
    )

    console.log(
      `[ProgressBar ${ts}] Current step:`,
      currentStep?.name || "none",
    )

    if (currentStep?.status === "started") {
      this.animateStep(currentStep)
    }
  },

  animateStep(step) {
    const bar = this.el.querySelector(
      `[data-step="${step.name}"] .progress-fill`,
    )
    if (!bar || this.timers[step.name]) return

    const duration = step.estimated_duration_ms || 1000
    const maxProgress = 95
    const intervalMs = 100
    const incrementPerTick = maxProgress / (duration / intervalMs)

    let progress = 0
    this.timers[step.name] = setInterval(() => {
      progress = Math.min(progress + incrementPerTick, maxProgress)
      bar.style.width = `${progress}%`

      if (progress >= maxProgress) {
        clearInterval(this.timers[step.name])
      }
    }, intervalMs)

    // Set up warning timeout (estimate + offset from data attribute)
    // Only enabled if data-warning-offset-ms is set
    if (!this.warningFired[step.name] && this.el.dataset.warningOffsetMs) {
      const warningOffsetMs = parseInt(this.el.dataset.warningOffsetMs)
      const warningDelay = duration + warningOffsetMs
      this.warningTimers[step.name] = setTimeout(() => {
        const currentStep = this.getCurrentStep()
        if (
          currentStep?.name === step.name &&
          currentStep?.status === "started"
        ) {
          this.warningFired[step.name] = true
          this.pushEventTo(this.el, "extraction_taking_longer", {
            step: step.name,
          })
        }
      }, warningDelay)
    }

    // Set up failure timeout (estimate * multiplier from data attribute)
    // Only enabled if data-timeout-estimate-multiplier is set
    if (
      !this.failureFired[step.name] &&
      this.el.dataset.timeoutEstimateMultiplier
    ) {
      const timeoutMultiplier = parseFloat(
        this.el.dataset.timeoutEstimateMultiplier,
      )
      const failureDelay = duration * timeoutMultiplier
      this.failureTimers[step.name] = setTimeout(() => {
        const currentStep = this.getCurrentStep()
        if (
          currentStep?.name === step.name &&
          currentStep?.status === "started"
        ) {
          this.failureFired[step.name] = true
          this.pushEventTo(this.el, "extraction_timeout", { step: step.name })
        }
      }, failureDelay)
    }
  },

  destroyed() {
    Object.values(this.timers).forEach(clearInterval)
    Object.values(this.warningTimers).forEach(clearTimeout)
    Object.values(this.failureTimers).forEach(clearTimeout)
  },
}
